import { ComponentProps } from "react";
import { optimizeImage } from "~/utils/storyblok.image.utils";

const StoryblokOptimizedImage = ({ src, ...rest }: ComponentProps<"img">) => {
  return <img src={optimizeImage({ src })} {...rest} />;
};

export default StoryblokOptimizedImage;
